
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static/privacy",
      function () {
        return require("private-next-pages/static/privacy.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static/privacy"])
      });
    }
  